module.exports = __webpack_public_path__ + "img/review-empty-1.161d43b9.svg";